import _ from 'lodash';

export default alarmLevels => _.map(alarmLevels, (severity, index) => ({
  min: Math.max(index - 0.5, 0),
  max: Math.min(index + 0.5, _.size(alarmLevels) - 1),
  severity
}));